module.exports = __webpack_public_path__ + "img/image2.c85685cf.png";